import React, { useState } from 'react';
import StyledTabs from '@components/common/Tabs';
import {
  ContentPanelWrapper,
  IconWrapper,
  SelectWrapper,
  StyledComingSoonIcon,
  TabContentWrapper,
} from './styled';
import { AUTO_SCAN_TABS, getOutliersTableColumns, OUTLIER_TYPE, TYPE_OPTIONS } from './utils';
import ActiveOutliersTable from './ActiveTab';
import ArchivedOutliersTable from './ArchivedTab';
import { useAtom } from 'jotai';
import { tabAtom } from './atoms';
import { Select } from 'antd';

const ContentPanel = () => {
  const [type, setType] = useState(OUTLIER_TYPE);
  const [tab, setTab] = useAtom(tabAtom);

  const onChangeType = (item) => {
    setType(item);
  };

  const onChangeTab = (key) => {
    setTab(key);
  };

  const getColumns = (tab) => (dimensionSearchProps: {}) =>
    getOutliersTableColumns({ tab, dimensionSearchProps });

  const getContent = (tab) => (
    <TabContentWrapper>
      {/* this table will be common for all upcoming tabs */}
      {tab === 'active' ? (
        <ActiveOutliersTable getColumns={getColumns(tab)} />
      ) : (
        <ArchivedOutliersTable getColumns={getColumns(tab)} />
      )}
    </TabContentWrapper>
  );

  const tabItems = AUTO_SCAN_TABS.map(({ key, displayName }) => ({
    key,
    label: displayName,
    children: getContent(key), // ReactNode
  }));

  return (
    <ContentPanelWrapper>
      <SelectWrapper>
        <Select
          defaultValue={{ key: OUTLIER_TYPE }}
          style={{ width: 'max-content', paddingLeft: '5px', zIndex: 100 }}
          variant="borderless"
          size={'large'}
          styles={{ popup: { root: { minWidth: '250px', padding: '10px 5px' } } }}
          options={TYPE_OPTIONS}
          onChange={onChangeType}
        />
      </SelectWrapper>
      {type === OUTLIER_TYPE ? (
        <StyledTabs defaultActiveKey={tab} items={tabItems} onChange={onChangeTab} />
      ) : (
        <IconWrapper>
          <StyledComingSoonIcon />
        </IconWrapper>
      )}
    </ContentPanelWrapper>
  );
};

export default ContentPanel;
